import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "../types/auth"
import parseToken from "src/utils/jwt";

const token = localStorage.getItem("token");
const refreshToken = localStorage.getItem("refreshToken");
const decoded = token ? parseToken(token) : null;

const initialState: AuthState = {
  token,
  refreshToken,
  decoded,
}

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    login: (state, action: PayloadAction<{token: string, refreshToken: string}>) => {
      const { token, refreshToken } = action.payload;
      localStorage.setItem("token", token);
      localStorage.setItem("refreshToken", refreshToken);
      state.token = token;
      state.refreshToken = refreshToken;
      state.decoded = parseToken(token);
    },
    logout(state) {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      state.token = null;
      state.decoded = null;
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
export const selectToken = (state: { auth: AuthState }) => state.auth.token;
export const selectDecoded = (state: { auth: AuthState }) => state.auth.decoded;